export const environment = {
    production: false,
    url: "https://api-zurich.policystreet.app/api",
};
